import React, { useMemo } from "react";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import AuthProvider from "../../auth/AuthProvider";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";

import { connect } from "react-redux";
import Algemeen from "./Algemeen";
import ScheduledTaskMetrics from "./ScheduledTaskMetrics";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

function ScheduledTaskForm(props) {
  const endPoint = useMemo(() => {
    return "core/scheduledTasks";
  }, []);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"scheduledTasks"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            extraFormProps={{ vestiging, vestigingId: vestiging?.id ?? props.vestiging_id, menukaartVestigingId }}
            // revalidateMode={"onChange"}
            // mode={"onSubmit"}
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.task_name);
            }}
            customFieldSerialization={{
              email_addresses_for_failure_notifications: (arr) => JSON.stringify(arr.map((row) => row.email)),
            }}
            endPoint={endPoint}
            extraFields={extraFields}
            onGetModel={onGetModel}
            pageTitle={getTranslation("scheduledTasks.form.pageTitle", "Scheduled Task")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{
              email_addresses_for_failure_notifications: (response) =>
                response?.map((row) => ({ id: row, email: row }) ?? []),
            }}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tKey={"scheduledTasks.form.tabs.algemeen"} tDefault={"Algemeen"} />,
                tabContent: <Algemeen />,
              },
              {
                right: "metrics",
                tabButton: <TranslationWrapper tKey={"scheduledTasks.form.tabs.metrics"} tDefault={"Metrics"} />,
                tabContent: <ScheduledTaskMetrics />,
              },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(ScheduledTaskForm);
